module.exports = __webpack_public_path__ + "static/img-services-b3d523f4a7ac501d461a618f07449992.png";